// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2xLq6","inputWrap":"styles_inputWrap__3UnNW","input":"styles_input__9hTOU"};